module.exports = __webpack_public_path__ + "img/antes_despues_233.34884896.png";